/** Camera assets sometimes omit width/height or report 0; never pass that to the compressor. */
export function photoResize(asset = {}, max = 1600) {
  const width = Number(asset.width);
  const height = Number(asset.height);
  const hasWidth = Number.isFinite(width) && width > 0;
  const hasHeight = Number.isFinite(height) && height > 0;
  if (hasWidth && hasHeight) return width >= height ? { width: Math.min(width, max) } : { height: Math.min(height, max) };
  if (hasWidth) return { width: Math.min(width, max) };
  if (hasHeight) return { height: Math.min(height, max) };
  return { width: max };
}

export function canvasSize(width, height, maxWidth = 1200) {
  const w = Number(width);
  const h = Number(height);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w < 1 || h < 1) return null;
  const scale = w > maxWidth ? maxWidth / w : 1;
  return { width: Math.max(1, Math.round(w * scale)), height: Math.max(1, Math.round(h * scale)) };
}
